import { useContext } from 'react';
import { SettingsContext } from './_contexts/SettingsContext';

// ----------------------------------------------------------------------

const useSettings = () => useContext(SettingsContext);

export default useSettings;
